"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (StatsD, options = {}) => {
    const datadog = new StatsD('localhost', 8125);
    const stat = options.stat || 'node.express.router';
    const tags = options.tags || [];
    return function dataDogMiddleware(req, res, next) {
        const startTime = Date.now();
        const { end } = res;
        res.end = function endResponse(data, encoding, callback) {
            res.end = end;
            res.end(data, encoding, callback);
            const route = req.route ? req.route.path : 'no-route';
            const statTags = [`route: ${req.baseUrl + route}`].concat(tags);
            statTags.push(`method: ${req.method.toLowerCase()}`);
            statTags.push(`protocol: ${req.protocol}`);
            statTags.push(`response_code: ${res.statusCode}`);
            datadog.increment(`${stat}.route.${route}`, 1, statTags);
            datadog.increment(`${stat}.response_code.${res.statusCode}`, 1, statTags);
            datadog.increment(`${stat}.response_code.all`, 1, statTags);
            datadog.histogram(`${stat}.response_time`, Date.now() - startTime, 1, statTags);
        };
        next();
    };
};
